export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold text-white font-head">{title}</h1>
        {subtitle && <p className="text-sm text-slate-400 mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return <div {...rest} className={`rounded-2xl bg-[#111827] border border-[#1E293B] ${className}`}>{children}</div>;
}

const STATUS_STYLES = {
  published: "bg-emerald-500/15 text-emerald-400",
  publiee: "bg-emerald-500/15 text-emerald-400",
  draft: "bg-slate-500/15 text-slate-400",
  brouillon: "bg-slate-500/15 text-slate-400",
  archived: "bg-rose-500/15 text-rose-400",
  nouveau: "bg-blue-500/15 text-blue-400",
  contacte: "bg-cyan-500/15 text-cyan-400",
  qualifie: "bg-violet-500/15 text-violet-400",
  opportunite: "bg-amber-500/15 text-amber-400",
  client: "bg-emerald-500/15 text-emerald-400",
  perdu: "bg-rose-500/15 text-rose-400",
};
const STATUS_LABELS = { published: "Publié", draft: "Brouillon", archived: "Archivé", nouveau: "Nouveau", contacte: "Contacté", qualifie: "Qualifié", opportunite: "Opportunité", client: "Client", perdu: "Perdu" };

export function StatusBadge({ status }) {
  const s = (status || "draft").toLowerCase();
  return <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${STATUS_STYLES[s] || "bg-slate-500/15 text-slate-400"}`}>{STATUS_LABELS[s] || status}</span>;
}

export function EmptyState({ text }) {
  return <div className="py-16 text-center text-slate-500">{text}</div>;
}
